import { Typography } from '@mui/material';
import { Column, Row, Spacer } from '../../../components';
import { Svgs } from '../../../assets/svg';
import { t } from 'i18next';

interface YourLifeGoalsProps {
  isMobile: boolean;
}

const YourLifeGoals: React.FC<YourLifeGoalsProps> = ({ isMobile }) => {
  return isMobile ? (
    <>
      <Spacer height='sm' />
      <Column style={{ alignItems: 'center' }}>
        <LifeGoalsArt />
      </Column>
      <Spacer height='xs' />
      <YourLifeGoalsPlanned />
      <Spacer height='xxs' />
      <WhenChoicesFeelOverwhelming />
    </>
  ) : (
    <>
      <Spacer height='sm' />
      <YourLifeGoalsPlanned />
      <Row style={{ alignItems: 'center', gap: '20px', marginTop: '15px' }}>
        <LifeGoalsArt />
        <WhenChoicesFeelOverwhelming />
      </Row>
    </>
  );
};

const WhenChoicesFeelOverwhelming: React.FC = () => (
  <Typography color='secondary' variant='body1'>
    {t('WhenChoicesFeelOverwhelming')}
  </Typography>
);

const YourLifeGoalsPlanned: React.FC = () => (
  <Typography color='secondary' variant='p18Bold'>
    {t('YourLifeGoalsPlanned')}
  </Typography>
);

const LifeGoalsArt: React.FC = () => (
  <Svgs.ArtTarget
    style={{
      width: '55px',
      height: 'auto',
      flexShrink: 0,
    }}
  />
);

export default YourLifeGoals;
